import { useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'
import posthog from 'posthog-js'
import { usePrevious } from 'react-use'

export const useTrackRouteID = () => {
  const routerState = useRouterState()

  const route_id = routerState.matches.at(-1)?.routeId ?? 'unknown'
  const prevRoute_id = usePrevious(route_id)

  useEffect(() => {
    if (prevRoute_id !== route_id) {
      posthog.capture('visited', { route_id })
    }
  }, [route_id, prevRoute_id])
}
